export const formatDate = (date) => {
  const d = new Date(date);
  const month = d.getMonth() + 1 + '';
  const year = d.getFullYear();
  const day = d.getDate() + '';

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export const addSignToPercentage = (value) => {
  const withoutPercentage = value.split('%')[0];
  let sign = '';
  if (Number(withoutPercentage) === 0) {
    sign = '';
  } else if (Number(withoutPercentage) < 0) {
    sign = '-';
  } else {
    sign = '+';
  }

  return sign + withoutPercentage.replace('-', '') + '%';
};

const getCountryCode = () => {
  const getProfile = window.location.href.indexOf('flipkart') > -1 
    ? JSON.parse(sessionStorage.getItem('flipkartProfile'))
    : JSON.parse(sessionStorage.getItem('selectedProfileId'));
  return getProfile?.countryCode || 'IN';
}

export const conditionallyRevenueInfoData = (number, includeDecimal = true, suppressDecimalsForLargeNumbers = false) => {
  const countryCode = getCountryCode();
  const num = Number(number || 0).toFixed(2);
  const absNum = Math.abs(Number(num));
  
  if (suppressDecimalsForLargeNumbers && absNum >= 10) {
    return Math.round(Number(num)).toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  
  if (!includeDecimal) {
    return Number(num).toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  if (num % 1 === 0) {
    if (num < 99) {
      return num.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return Math.round(num).toLocaleString(`en-${countryCode}`);
  } else {
    if (num > 100 || num < -100) {
      return Math.round(num).toLocaleString(`en-${countryCode}`);
    }
    return num.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
};

export const conditionallyRevenueInfoDataFixedZero = (number) => {
  const countryCode = getCountryCode();
  const num = Number(number || 0).toFixed(0);
  const roundedNum = Math.round(num);

  if (roundedNum % 1 === 0) {
    if(roundedNum < 99) return roundedNum.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    return roundedNum.toLocaleString(`en-${countryCode}`);
  } else {
    if (roundedNum > 100 || roundedNum < -100) {
      return roundedNum.toLocaleString(`en-${countryCode}`);
    }
    return roundedNum.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
};

const conditionallyRevenueInfoDataFixedZeroWithDecimal = (number) => {
  const countryCode = getCountryCode();
  const num = Number(number || 0).toFixed(2);
  const roundedNum = Math.round(num);

  if (roundedNum % 1 === 0) {
    if(roundedNum > 99) return roundedNum.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    return num.toLocaleString(`en-${countryCode}`);
  } else {
    if (roundedNum > 99 || roundedNum < -99) {
      return roundedNum.toLocaleString(`en-${countryCode}`);
    }
    return num.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
}

const conditionallyPercentageData = (number, suppressDecimalsForLargeNumbers = false) => {
  const countryCode = getCountryCode();
  const num = Number(number || 0).toFixed(2);
  if (num < 99 && num > -99) {
    return num.toLocaleString(`en-${countryCode}`, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else {
    return conditionallyRevenueInfoData(num, false, suppressDecimalsForLargeNumbers);
  }
};

export const getRevenueInfoAggregateData = (currencyIcon, number, unit, suppressDecimalsForLargeNumbers = false) => {
  const data = {
    number: conditionallyRevenueInfoData(number, false, suppressDecimalsForLargeNumbers),
    digit: conditionallyRevenueInfoData(number, true, suppressDecimalsForLargeNumbers),
    decimal: conditionallyRevenueInfoData(number, true, suppressDecimalsForLargeNumbers),
    currency: currencyIcon + conditionallyRevenueInfoDataFixedZero(number),
    decimal_currency: currencyIcon + conditionallyRevenueInfoDataFixedZeroWithDecimal(number),
    percentage: conditionallyPercentageData(number, suppressDecimalsForLargeNumbers) + '%'
  };

  return data[unit] || conditionallyRevenueInfoData(number, false, suppressDecimalsForLargeNumbers);
};

export const getDifferences = (revenueInfoData, details) => {
  const v1 = revenueInfoData?.[details.aggregate] || 0;
  const v2 = revenueInfoData?.compare_data?.[details.aggregate] || 0;
  const value = ((v1 - v2) / v2) * 100;
  return value !== Infinity && !isNaN(value) ? value : 0;
};

export const formatPercentage = (number) => {
  if (number < 100 && number > -0.99) return parseFloat(number).toFixed(2);
  let formattedNumber = Number(number);
  return formattedNumber % 1 === 0 ? formattedNumber.toFixed(0) : formattedNumber.toFixed(2);
};

export const getStatus = (data, getDifferences, isLoading, inverted, aggregate) => {
  if (isLoading) return 'ideal';

  if (!isNaN(data) && getDifferences === 0) return 'equal';

  if (String(aggregate)?.toLowerCase().indexOf('acos') > -1) {
    if (getDifferences > 0) {
      return 'low';
    } else {
      return 'high';
    }
  }

  if (String(aggregate)?.toLowerCase().indexOf('roas') > -1) {
    if (getDifferences < 0) {
      return 'low';
    } else {
      return 'high';
    }
  }

  if (getDifferences > 0) {
    return inverted ? 'low' : 'high';
  }

  if (getDifferences < 0) {
    return inverted ? 'high' : 'low';
  }
};

export const  getLineChartData = (data, aggregate) => {
  return { data: data?.['all_dates_' + aggregate]?.map((item) => item?.value) || [], lineWidth: 2, name: 'null' };
};

export const GROWTH_STATUS_BORDER_COLOR = {
  DARK: {
    high: 'rgb(21 128 61)',
    low: 'rgb(127 29 29)',
    ideal: '#949191',
    equal: 'rgb(234 88 12)'
  },
  LIGHT: {
    high: '#0DBC68',
    low: '#f3253b',
    ideal: '#949191',
    equal: 'rgb(249 115 22)'
  }
};

export const COLORS = [
  ['#D095EF', '#4F27F7'],
  ['#86EAD4', '#43B9A9'],
  ['#F43899', '#FA3496'],
  ['#FFBAE0', '#FFBAE0'],
  ['#9B82F8', '#9B82F8'],
  ['#0984D6', '#57B8F8'],
  ['#65ba74', '#94CE9A'],
  ['#FFBA18', '#FBE577'],
  ['#7CE2FE', '#00749E'],
  ['#DC3E42', '#E5484D'],
  ['#AB4ABA', '#CF91D8'],
  ['#3E63DD', '#3A5BC7'],
  ['#00A2C7', '#3DB9CF'],
  ['#A18072', '#D3BCB3'],
  ['#FFE629', '#E4C767'],
];


export const getMetricDifferences = (revenueInfoData, metric) => {
  const v1 = revenueInfoData?.[`total${metric}`] || 0;
  const v2 = revenueInfoData?.[`prev${metric}`] || 0;
  const value = ((v1 - v2) / v2) * 100;
  return value !== Infinity && !isNaN(value) ? value : 0;
};

export const getMetricDifferencesDayParting = (revenueInfoData, metric) => {
  const v1 = revenueInfoData?.[`total${metric}`] || 0;
  const v2 = revenueInfoData?.[`prev${metric}`] || 0;
  if (v2 === 0) {
    return v1 === 0 ? 0 : 100;  // If both are 0, return 0; if only v2 is 0, return 100% increase
  }
  const value = ((v1 - v2) / Math.abs(v2)) * 100;
  return isFinite(value) ? value : 0;
};

export const getDspDetails = (selectedProfile, masterAccountFilter) => {
  if (!selectedProfile || !selectedProfile?.dsp || selectedProfile?.dsp?.length === 0) {
      return null;
  }

  if (
      masterAccountFilter &&
      selectedProfile?.profileId &&
      masterAccountFilter[selectedProfile?.profileId] &&
      masterAccountFilter[selectedProfile?.profileId].length > 0
  ) {
      const selectedDspId = masterAccountFilter[selectedProfile?.profileId]?.find((item) => item?.level === "dsp")?.keywords;
      const selectedDspAccount = selectedProfile?.dsp?.find((item) =>
          Array.isArray(selectedDspId) && selectedDspId?.length > 0
              ? item?.dspId === selectedDspId?.[0]
              : item?.dspId === String(selectedDspId)
      );

      return selectedDspAccount || selectedProfile?.dsp?.[0];
  }

  return selectedProfile?.dsp?.[0];
};

